interface DataType {
   id: number;
   page: string;
   course_details: {
      id: number;
      thumb: string;
      tag: string;
      review: string;
      title: string;
      duration?: string;
      author?: string;
      price: number;
      lesson?: string;
      minute?: string;
      image?: string;
      overview?: {
         description: string;
         learnings: string[];
         extraNote: string;
       };
      curriculum?:string;
      instructorsList?:string[];
   }[]
};

const course_data: DataType[] = [
   
   {
      id: 1,
      page: "home_1",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/course_thumb01.jpg",
            tag: "Core Skills",
            review: "(4.8 Reviews)",
            title: "Java in Projects",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
            image:"/assets/img/courses/courses_details.png",
            overview:
            {description: "This course is designed to help you understand the basics of Java programming. You will learn the fundamentals of Java programming and how to create Java applications. You will also learn about object-oriented programming concepts and how to use them in Java applications.",
               learnings: ["Understand the basics of Java programming", "Create Java applications", "Learn about object-oriented programming concepts", "Use object-oriented programming concepts in Java applications"],
               extraNote: "This course is designed for beginners who have no prior programming experience."
            }
         },
         {
            id: 2,
            thumb: "/assets/img/courses/course_thumb02.jpg",
            tag: "Database",
            review: "(4.5 Reviews)",
            title: "SQL Essentials",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 3,
            thumb: "/assets/img/courses/course_thumb03.jpg",
            tag: "Front-end",
            review: "(4.3 Reviews)",
            title: "UI & JavaScript",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 4,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Front-end",
            review: "(4.8 Reviews)",
            title: "Angular",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 5,
            thumb: "/assets/img/courses/course_thumb05.jpg",
            tag: "Front-end",
            review: "(4.5 Reviews)",
            title: "React",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 7,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Core Skills",
            review: "(4.8 Reviews)",
            title: "Power of Python",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
         id: 9,
         thumb: "/assets/img/courses/course_thumb04.jpg",
         tag: "Data Science",
         review: "(4.8 Reviews)",
         title: "Maching Learning",
         duration: "4 Weeks",
         author: "David Millar",
         price: 799,
      },
      ]
   },
   {
      id: 2,
      page: "home_1",
      course_details: [
         {
            id: 6,
            thumb: "/assets/img/courses/course_thumb06.jpg",
            tag: "Development",
            review: "(4.7 Reviews)",
            title: "Java Spring Boot",
            duration: "8 Weeks",
            author: "David Millar",
            price: 4999,
         },
         {
            id: 8,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Development",
            review: "(4.8 Reviews)",
            title: "MERN Stack",
            duration: "8 Weeks",
            author: "David Millar",
            price: 4999,
         },
         {
            id: 3,
            thumb: "/assets/img/courses/course_thumb03.jpg",
            tag: "Test Automation",
            review: "(4.3 Reviews)",
            title: "Selenium Test Automation",
            duration: "8 Weeks",
            author: "David Millar",
            price: 3999,
         },
         // {
         //    id: 4,
         //    thumb: "/assets/img/courses/course_thumb04.jpg",
         //    tag: "Database",
         //    review: "(4.8 Reviews)",
         //    title: "DBA",
         //    author: "David Millar",
         //    price: 12,
         // },
       
      ]
   },
   {
      id: 3,
      page: "home_1",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Projects",
            review: "(4.8 Reviews)",
            title: "Angular + Spring Boot Projects",
            duration: "12 Weeks",
            author: "David Millar",
            price: 29000,
         },
         {
            id: 2,
            thumb: "/assets/img/courses/course_thumb05.jpg",
            tag: "Projects",
            review: "(4.5 Reviews)",
            title: "React with Node.js projects",
            duration: "12 Weeks",
            author: "David Millar",
            price: 29000,
         },
         {
            id: 3,
            thumb: "/assets/img/courses/course_thumb06.jpg",
            tag: "Projects",
            review: "(4.7 Reviews)",
            title: "Mobile App Development",
            duration: "12 Weeks",
            author: "David Millar",
            price: 29000,
         },
        
      ]
   },
   {
      id: 4,
      page: "home_1",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/course_thumb01.jpg",
            tag: "Core Skills",
            review: "(4.8 Reviews)",
            title: "Java in Projects",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 2,
            thumb: "/assets/img/courses/course_thumb02.jpg",
            tag: "Database",
            review: "(4.5 Reviews)",
            title: "SQL Essentials",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 3,
            thumb: "/assets/img/courses/course_thumb03.jpg",
            tag: "Front-end",
            review: "(4.3 Reviews)",
            title: "UI & JavaScript",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 4,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Front-end",
            review: "(4.8 Reviews)",
            title: "Angular",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 5,
            thumb: "/assets/img/courses/course_thumb05.jpg",
            tag: "Front-end",
            review: "(4.5 Reviews)",
            title: "React",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 6,
            thumb: "/assets/img/courses/course_thumb06.jpg",
            tag: "Development",
            review: "(4.7 Reviews)",
            title: "Java Spring Boot",
            duration: "8 Weeks",
            author: "David Millar",
            price: 4999,
         },
         {
            id: 7,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Core Skills",
            review: "(4.8 Reviews)",
            title: "Power of Python",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
            id: 8,
            thumb: "/assets/img/courses/course_thumb04.jpg",
            tag: "Core Skills",
            review: "(4.8 Reviews)",
            title: "Node.js",
            duration: "4 Weeks",
            author: "David Millar",
            price: 399,
         },
         {
         id: 9,
         thumb: "/assets/img/courses/course_thumb04.jpg",
         tag: "Data Science",
         review: "(4.8 Reviews)",
         title: "Maching Learning",
         duration: "4 Weeks",
         author: "David Millar",
         price: 799,
      },
      ]
   },

   // home_8

   {
      id: 1,
      page: "home_8",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 75,
            lesson: "05",
            minute: "34",
         },
         {
            id: 2,
            thumb: "/assets/img/courses/h8_course_thumb02.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 22,
            lesson: "05",
            minute: "20",
         },
         {
            id: 3,
            thumb: "/assets/img/courses/h8_course_thumb03.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 19,
            lesson: "05",
            minute: "30",
         },
         {
            id: 4,
            thumb: "/assets/img/courses/h8_course_thumb04.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 79,
            lesson: "05",
            minute: "304",
         },
         {
            id: 5,
            thumb: "/assets/img/courses/h8_course_thumb05.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 49,
            lesson: "05",
            minute: "30",
         },
         {
            id: 6,
            thumb: "/assets/img/courses/h8_course_thumb06.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 25,
            lesson: "05",
            minute: "44",
         },
         {
            id: 7,
            thumb: "/assets/img/courses/h8_course_thumb07.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 59,
            lesson: "05",
            minute: "30",
         },
         {
            id: 8,
            thumb: "/assets/img/courses/h8_course_thumb02.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 15,
            lesson: "05",
            minute: "22",
         },
      ]
   },
   {
      id: 2,
      page: "home_8",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/h8_course_thumb05.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 49,
            lesson: "05",
            minute: "30",
         },
         {
            id: 2,
            thumb: "/assets/img/courses/h8_course_thumb06.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 25,
            lesson: "05",
            minute: "44",
         },
         {
            id: 3,
            thumb: "/assets/img/courses/h8_course_thumb07.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 59,
            lesson: "05",
            minute: "30",
         },
         {
            id: 4,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 15,
            lesson: "05",
            minute: "22",
         },
         {
            id: 5,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 75,
            lesson: "05",
            minute: "34",
         },
         {
            id: 6,
            thumb: "/assets/img/courses/h8_course_thumb02.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 22,
            lesson: "05",
            minute: "20",
         },
         {
            id: 7,
            thumb: "/assets/img/courses/h8_course_thumb03.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 19,
            lesson: "05",
            minute: "30",
         },
         {
            id: 8,
            thumb: "/assets/img/courses/h8_course_thumb04.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 79,
            lesson: "05",
            minute: "304",
         },
      ]
   },
   {
      id: 3,
      page: "home_8",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 75,
            lesson: "05",
            minute: "34",
         },
         {
            id: 2,
            thumb: "/assets/img/courses/h8_course_thumb02.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 22,
            lesson: "05",
            minute: "20",
         },
         {
            id: 3,
            thumb: "/assets/img/courses/h8_course_thumb03.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 19,
            lesson: "05",
            minute: "30",
         },
         {
            id: 4,
            thumb: "/assets/img/courses/h8_course_thumb04.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 79,
            lesson: "05",
            minute: "304",
         },
         {
            id: 5,
            thumb: "/assets/img/courses/h8_course_thumb05.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 49,
            lesson: "05",
            minute: "30",
         },
         {
            id: 6,
            thumb: "/assets/img/courses/h8_course_thumb06.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 25,
            lesson: "05",
            minute: "44",
         },
         {
            id: 7,
            thumb: "/assets/img/courses/h8_course_thumb07.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 59,
            lesson: "05",
            minute: "30",
         },
         {
            id: 8,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 15,
            lesson: "05",
            minute: "22",
         },
      ]
   },
   {
      id: 4,
      page: "home_8",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/h8_course_thumb05.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 49,
            lesson: "05",
            minute: "30",
         },
         {
            id: 2,
            thumb: "/assets/img/courses/h8_course_thumb06.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 25,
            lesson: "05",
            minute: "44",
         },
         {
            id: 3,
            thumb: "/assets/img/courses/h8_course_thumb07.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 59,
            lesson: "05",
            minute: "30",
         },
         {
            id: 4,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 15,
            lesson: "05",
            minute: "22",
         },
         {
            id: 5,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 75,
            lesson: "05",
            minute: "34",
         },
         {
            id: 6,
            thumb: "/assets/img/courses/h8_course_thumb02.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 22,
            lesson: "05",
            minute: "20",
         },
         {
            id: 7,
            thumb: "/assets/img/courses/h8_course_thumb03.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 19,
            lesson: "05",
            minute: "30",
         },
         {
            id: 8,
            thumb: "/assets/img/courses/h8_course_thumb04.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 79,
            lesson: "05",
            minute: "304",
         },
      ]
   },
   {
      id: 5,
      page: "home_8",
      course_details: [
         {
            id: 1,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 15,
            lesson: "05",
            minute: "22",
         },
         {
            id: 2,
            thumb: "/assets/img/courses/h8_course_thumb01.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 75,
            lesson: "05",
            minute: "34",
         },
         {
            id: 3,
            thumb: "/assets/img/courses/h8_course_thumb02.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 22,
            lesson: "05",
            minute: "20",
         },
         {
            id: 4,
            thumb: "/assets/img/courses/h8_course_thumb05.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 49,
            lesson: "05",
            minute: "30",
         },
         {
            id: 5,
            thumb: "/assets/img/courses/h8_course_thumb06.jpg",
            tag: "Chinese",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 25,
            lesson: "05",
            minute: "44",
         },
         {
            id: 6,
            thumb: "/assets/img/courses/h8_course_thumb07.jpg",
            tag: "Dessert",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 59,
            lesson: "05",
            minute: "30",
         },
         {
            id: 7,
            thumb: "/assets/img/courses/h8_course_thumb03.jpg",
            tag: "Pizza",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 19,
            lesson: "05",
            minute: "30",
         },
         {
            id: 8,
            thumb: "/assets/img/courses/h8_course_thumb04.jpg",
            tag: "Italian",
            review: "(4.8 Reviews)",
            title: "It Statistics Data Science And Business Analysis",
            price: 79,
            lesson: "05",
            minute: "304",
         },
      ]
   },
];

export default course_data;